// @flow
import React, { useState } from 'react';
import useIsomorphicLayoutEffect from '../../../utils/useIsomorphicLayoutEffect';
import { useSelector } from 'react-redux';
import { Ads } from '@finect/tabular-components/Ads';
import { Inner, BlockContent } from './partials';

type Props = {
  targeting?: Object,
  margin?: 'left' | 'right'
};

export const LateralAd = ({ targeting = {}, margin }: Props) => {
  const [isVisible, setIsVisible] = useState(false);
  const omninavState: 'opened' | 'closed' = useSelector(state => state.omninav.state);

  useIsomorphicLayoutEffect(() => {
    // 1286 = x + 36*2
    setIsVisible(window.innerWidth >= 1280);
  }, []);

  if (!isVisible) return null;

  return (
    <Inner omninavState={omninavState}>
      <BlockContent margin={margin}>
        <Ads id="Finect_Side2" targeting={targeting} />
      </BlockContent>
    </Inner>
  );
};
